import { EModalSize, EPredefinedModalIds } from 'src/constants/modals';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';

import { AuthRegisterForms } from 'src/components/AuthRegisterForms';
import { BaseGenericModal } from 'src/components/BaseGenericModal';
import { TModalAuthProps } from './ModalAuth.types';
import { closeModal } from 'src/redux/modals/modals.slice';
import { routesConfig } from 'src/routes/routes.config';
import s from './ModalAuth.module.scss';
import { selectIsModalOpened } from 'src/redux/modals/modals.selectors';
import { useAppDispatch } from 'src/redux/store';
import { useAppLocation } from 'src/hooks/useAppLocation';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

export const ModalAuth: React.FC<TModalAuthProps> = () => {
  const modalRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { routeName } = useAppLocation();

  const isLoginModalOpened = useSelector(selectIsModalOpened(EPredefinedModalIds.MODAL_AUTH_LOGIN));
  const isRegisterModalOpened = useSelector(
    selectIsModalOpened(EPredefinedModalIds.MODAL_AUTH_REGISTER),
  );

  const modalId = useMemo(() => {
    if (isLoginModalOpened) {
      return EPredefinedModalIds.MODAL_AUTH_LOGIN;
    }

    if (isRegisterModalOpened) {
      return EPredefinedModalIds.MODAL_AUTH_REGISTER;
    }

    return '';
  }, [isLoginModalOpened, isRegisterModalOpened]);

  const [showLoginBlock, setShowLoginBlock] = useState<boolean>(isLoginModalOpened);

  useLayoutEffect(() => {
    setShowLoginBlock(modalId === EPredefinedModalIds.MODAL_AUTH_LOGIN);
  }, [modalId]);

  function closeAuthModal() {
    dispatch(closeModal(modalId));

    if (routeName === 'accountActivated') {
      history.push(routesConfig.singularityMap());
    }
  }

  if (!isLoginModalOpened && !isRegisterModalOpened) return null;

  return (
    <>
      <div className={s.background} />
      <BaseGenericModal
        className={s.modal}
        modalId={modalId}
        size={showLoginBlock ? EModalSize.XL465 : EModalSize.XL500}
        modalRef={modalRef}>
        <AuthRegisterForms
          showCloseButton
          onCloseButtonClick={() => {
            closeAuthModal();
          }}
          onSuccess={() => {
            closeAuthModal();
          }}
        />
      </BaseGenericModal>
    </>
  );
};
